module.exports = __webpack_public_path__ + "static/nuclyaa.f98a57a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nuclyaa.png
// module id = 532
// module chunks = 117206707316740